import Button from '@material-ui/core/Button';
import React from 'react';
import { customStyles } from '../Styles/UIStyles';
import TextField from '../UIElements/TextField';

export const BlogsForm = () => {

    const styles = customStyles();

    return (
        <div>
            <p className={styles.form_header}>
                Title
            </p>
            <TextField className={styles.textfield}
                id="blog_title"
                name="blog_title"
                label="Enter a title"
            />
            <p className={styles.form_header}>
                Subtitle
            </p>
            <TextField className={styles.textfield}
                id="blog_subtitle"
                name="blog_subtitle"
                label="Enter a sub title"
            />
            <br />
            <br />
            <Button className={styles.primary_button} type="submit" id="manage_blogs" name="manage_blogs" variant="outlined" >
                Manage Blogs
            </Button>
            <br />
        </div >
    )
}
